import { render, staticRenderFns } from "./Stream.vue?vue&type=template&id=2f37cc2d&scoped=true&"
import script from "./Stream.vue?vue&type=script&lang=js&"
export * from "./Stream.vue?vue&type=script&lang=js&"
import style0 from "./Stream.vue?vue&type=style&index=0&id=2f37cc2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37cc2d",
  null
  
)

export default component.exports